var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothingtosee text-center"},[_c('img',{attrs:{"src":require(`../../assets/${_vm.image}.svg`)}}),_c('EmptyInfo',{attrs:{"title":_vm.title,"description":_vm.description,"buttonText":_vm.buttonText},on:{"emptyClick":_vm.emptyClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }